import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { BodyText } from '../../../../Text';
import { type ButtonFluidLabelPalette, paletteStyles } from './ButtonFluidLabel.pallets';

// ─────────────────────────────────────────────────────────────────────────────

export const ButtonFluidLabel = (props: ButtonFluidLabelProps) => {
  const { children, palette = 'lime', disabled, style, ...restProps } = props;

  // ─── Styles ──────────────────────────────────────────────────────────

  const textPaletteStyles = disabled ? paletteStyles.disabled : paletteStyles[palette];
  const textStyles = [styles.text, textPaletteStyles, style];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.textContainer}>
      <BodyText sizeMatch={['22']} style={textStyles} {...restProps}>
        {children}
      </BodyText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  textContainer: {
    flex: 1,
  },
  text: {
    color: theme.colors.LIME, // default color
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ButtonFluidLabelProps = {
  /**
   * @default "lime"
   */
  palette?: ButtonFluidLabelPalette;
  disabled?: boolean | null;
} & Omit<ComponentProps<typeof BodyText>, 'disabled'>;
